// Taken from https://gist.github.com/markgoodyear/9496715
function scrollTo (el, Y, duration, easingFunction = easing.easeInOutQuad, callback) {
  const start = Date.now()
  const from = el.scrollTop

  if (from === Y) {
    callback && callback()
    return /* Prevent scrolling to the Y point if already there */
  }

  function min (a, b) {
    return a < b ? a : b
  }

  function scroll (timestamp) {
    const currentTime = Date.now()
    const time = min(1, ((currentTime - start) / duration))
    const easedT = easingFunction(time)

    el.scrollTop = (easedT * (Y - from)) + from

    if (time < 1) {
      requestAnimationFrame(scroll)
    } else {
      callback && callback()
    }
  }

  requestAnimationFrame(scroll)
}
/* bits and bytes of the scrollTo function inspired by the works of Benjamin DeCock */

/*
 * Easing Functions - inspired from http://gizma.com/easing/
 * only considering the t value for the range [0, 1] => [0, 1]
 */
const easing = {
  // no easing, no acceleration
  linear: function (t) { return t },
  // accelerating from zero velocity
  easeInQuad: function (t) { return t * t },
  // decelerating to zero velocity
  easeOutQuad: function (t) { return t * (2 - t) },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t },
  // accelerating from zero velocity
  easeInCubic: function (t) { return t * t * t },
  // decelerating to zero velocity
  easeOutCubic: function (t) { return (--t) * t * t + 1 },
  // acceleration until halfway, then deceleration
  easeInOutCubic: function (t) { return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1 },
  // accelerating from zero velocity
  easeInQuart: function (t) { return t * t * t * t },
  // decelerating to zero velocity
  easeOutQuart: function (t) { return 1 - (--t) * t * t * t },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function (t) { return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t },
  // accelerating from zero velocity
  easeInQuint: function (t) { return t * t * t * t * t },
  // decelerating to zero velocity
  easeOutQuint: function (t) { return 1 + (--t) * t * t * t * t },
  // acceleration until halfway, then deceleration
  easeInOutQuint: function (t) { return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t }
}

export {
  scrollTo,
  easing
}
